var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mt-3",attrs:{"id":"table_5"}},[_vm._v(" Laadpunten per Regio ")]),_c('TableManager',{ref:"TableManager",staticClass:"RVBChargingpointCount",attrs:{"loading":_vm.loading,"source-records":_vm.records,"category":"rvb-customer-reporting","uuid":"81daa378-e75a-4a5a-b224-4c48849a8bef"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }